import { useSelector } from 'react-redux';

import { CampaignTriggerType, CampaignType } from '@dev/ee-api/ee-api-models';
import { isEmpty } from 'lodash-es';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';

export const useGetAutomatedInfo = () => {
    const { isLoading, isNew, campaign } = useSelector(getCampainCreatorStore);

    const isDataLoaded = !isLoading && !isEmpty(campaign);
    const isAutomatedEdit = isDataLoaded && campaign.Type === CampaignType.Automated && !isNew;

    const triggerType = isAutomatedEdit ? campaign.TriggerOptions?.Type : CampaignTriggerType.OnAdd;
    const triggerChannelName = isAutomatedEdit ? campaign.TriggerOptions?.TriggeredBy?.ChannelName : null;
    const triggerData = isAutomatedEdit ? campaign.TriggerOptions?.TriggeredBy?.Data : null;

    return { isAutomatedEdit, triggerType, triggerChannelName, triggerData };
};
